import { KYMW1704Model } from '../kymw1704.model';
import { ImageSingleRegistDataModel } from '../vo/image-single-regist-data.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';


/**
 * 画面再表示時の情報取得するサービス
 *
 * @export RegistImageSingleService
 * @class RegistImageSingleService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class RegistImageSingleService extends PlessJsonResponderSub<any> {

  private vo: ImageSingleRegistDataModel;

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1704Model}
   * @memberof RegistImageSingleService
   */
  private model: KYMW1704Model;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof RegistImageSingleService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistImageSingleService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        imageFilePNG: this.vo.imageFilePNG,
        imageFileEPS: this.vo.imageFileEPS,
        startOrderCode: this.vo.startOrderCode,
        endOrderCode: this.vo.endOrderCode,
        imageBelongId: this.vo.imageBelongID,
        imageKind: this.vo.imageKind,
        imageType: this.vo.imageType,
        processInstruct: this.vo.processInstruct,
        cookingExPublish: this.vo.cookingExPublish,
        pCode: this.vo.pCode,
        cookingDiv: this.vo.cookingDiv,
        cookingName: this.vo.cookingName,
        materialName: this.vo.materialName,
        keyWord: this.vo.keyWord,
        eventId: this.vo.eventID,
        remarks: this.vo.remarks,
        billingTargetDiv: this.vo.billingTargetDiv,
        sampleOrderingCode: this.vo.sampleOrderingCode,
        billingCode: this.vo.billingCode,
        photoContentsDiv: this.vo.photoContentsDiv,
        photoInstructContents: this.vo.photoInstructContents,
        photoSchedule: this.vo.photoSchedule,
        photoStudioId: this.vo.photoStudioID,
        imageID: this.vo.imageId,
        imageName: this.vo.imageName,
        imageNameBranch: this.vo.imageNameBranch,
        imageFileName: this.vo.imageFileName,
        jpgUpdateFlg: this.vo.jpgUpdateFlg,
        textCaption: this.vo.textCaption
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof RegistImageSingleService
   */
  execute(model: any, vo: ImageSingleRegistDataModel, successFunc: Function): void {
    this.model = <KYMW1704Model>model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('KYMW1704RegistImageSingle', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistImageSingleService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
